import { useSession } from './useSession';

export const useUser = (pharmacyId?: string) => {
  const { session } = useSession(pharmacyId);

  return session?.user;
};
